import { AppColorContainer } from "../AppColorContainer";
import { IAppThemeFactory } from "../IAppThemeFactory";
import { DarkModeWordAppColorContainer } from "./DarkModeWordAppColorContainer";
import { LightModeWordAppColorContainer } from "./LightModeWordAppColorContainer";

// This is the WordThemeFactory which will initiate AppColorContainer for Dark/Light theme in Word app.
export class WordThemeFactory implements IAppThemeFactory {
  GetThemeColorContainer(isDarkModeEnabled : boolean) : AppColorContainer {
    if (isDarkModeEnabled) {
      return DarkModeWordAppColorContainer.GetInstance();
    } else {
      return LightModeWordAppColorContainer.GetInstance();
    }
  }
}